import { render, staticRenderFns } from "./LoaderModal.vue?vue&type=template&id=b1712964&scoped=true"
import script from "./LoaderModal.vue?vue&type=script&lang=js"
export * from "./LoaderModal.vue?vue&type=script&lang=js"
import style0 from "./LoaderModal.vue?vue&type=style&index=0&id=b1712964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1712964",
  null
  
)

export default component.exports